import {RootState} from "../reducer";
import {_CALL_API} from "../../middleware/api";
import {route} from "../../../conf/routes";
import { IProduct } from "src/type/product";

export const UtilsAction = Object.freeze({ 
    INIT_MAP_CATEGORIES_REQUEST: 'init_map_categories_request',
    INIT_MAP_CATEGORIES_SUCCESS: 'init_map_categories_success',
    INIT_MAP_CATEGORIES_FAILURE: 'init_map_categories_failure',
    INIT_MAP_PRODUCT_TYPE_REQUEST: 'init_map_product_type_request',
    INIT_MAP_PRODUCT_TYPE_SUCCESS: 'init_map_product_type_success',
    INIT_MAP_PRODUCT_TYPE_FAILURE: 'init_map_product_type_failure',
    UPDATE_COTATION_PRODUCT_SELECTED: 'update_cotation_product_selected',

    initMapNameCategories :() => (dispatch, getState: () => RootState) => {
        return dispatch({
          [_CALL_API]: {
            types: [ 
                UtilsAction.INIT_MAP_CATEGORIES_REQUEST, 
                UtilsAction.INIT_MAP_CATEGORIES_SUCCESS, 
                UtilsAction.INIT_MAP_CATEGORIES_FAILURE 
            ],
            route: route.category.fetch()
          }
        })
    },

    initMapProductType :() => (dispatch, getState: () => RootState) => {
      return dispatch({
        [_CALL_API]: {
          types: [ 
              UtilsAction.INIT_MAP_PRODUCT_TYPE_REQUEST, 
              UtilsAction.INIT_MAP_PRODUCT_TYPE_SUCCESS, 
              UtilsAction.INIT_MAP_PRODUCT_TYPE_FAILURE 
          ],
          route: route.products.getProductType()
        }
      })
  },
  updateCotatonProductSelected: (product: IProduct) => (dispatch, getState: () => RootState) => {
    return dispatch({
        type: UtilsAction.UPDATE_COTATION_PRODUCT_SELECTED,
        product
    })
  } 
})





// WEBPACK FOOTER //
// ./src/core/redux/action/utilsAction.ts